import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-1ae0c9e0"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  "class": "col-xl-4 order-xl-2 mb-5 mb-xl-0 mt-6"
};
var _hoisted_2 = {
  "class": "card card-profile shadow"
};
var _hoisted_3 = {
  "class": "row justify-content-center"
};
var _hoisted_4 = {
  "class": "col-lg-3 order-lg-2"
};
var _hoisted_5 = {
  "class": "card-profile-image"
};
var _hoisted_6 = {
  href: "#"
};
var _hoisted_7 = ["src"];
var _hoisted_8 = {
  "class": "card-header text-center border-0 pt-8 pt-md-4 pb-0 pb-md-4"
};
var _hoisted_9 = {
  "class": "text-right"
};
var _hoisted_10 = {
  "class": "card-body pt-0 pt-md-4 mt-5"
};
var _hoisted_11 = {
  "class": "row"
};
var _hoisted_12 = {
  "class": "col"
};
var _hoisted_13 = {
  "class": "card-profile-stats d-flex justify-content-center mt-md-5"
};
var _hoisted_14 = {
  "class": "heading"
};
var _hoisted_15 = {
  "class": "text-left"
};

var _hoisted_16 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("hr", {
    "class": "my-4"
  }, null, -1);
});

var _hoisted_17 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_base_button = _resolveComponent("base-button");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("a", _hoisted_6, [_createElementVNode("img", {
    src: $props.market.poster,
    "class": "rounded-circle"
  }, null, 8, _hoisted_7)])])])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createVNode(_component_base_button, {
    size: "sm",
    type: "default",
    "class": "float-right",
    onClick: $options.goToExchange
  }, {
    "default": _withCtx(function () {
      return [_createTextVNode(_toDisplayString(_ctx.$t("button.exchange")), 1)];
    }),
    _: 1
  }, 8, ["onClick"])])]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", null, [_createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t("label." + $props.market.title)), 1)])])])]), _createElementVNode("div", _hoisted_15, [_hoisted_16, _createElementVNode("p", {
    innerHTML: _ctx.$t("label." + $props.market.intro)
  }, null, 8, _hoisted_17)])])])]);
}